// adding some validations logic for user profile update form
import { required, email, minLength, numeric } from 'vuelidate/lib/validators'

export const FORM_UPDATE_PROFILE = {
  userDataForm: {
    name: {
      required,
      minLength: minLength(3)
    },
    surname: {
      required,
      minLength: minLength(3)
    },
    phonenumber: {
      numeric,
      minLength: minLength(10)
    },
    address: {
      minLength: minLength(15)
    },
    email: {
      required,
      email
    },
    newpassword: {
      minLength: minLength(0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formUpdateProfile.js